import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";

const DynamicSidebar = ({
  onSubCategorySelect,
  disabledSubcategory,
  initialSubcategory,
}) => {
  const UserId = "66abc123def4567890abcd12";

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState({});
  const [openCategory, setOpenCategory] = useState(null);
  const [activeSubcategory, setActiveSubcategory] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await fetch(getApiUrl("category-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userid: UserId }),
      });
      const result = await res.json();
      if (result.success && result.data.length > 0) {
        setCategories(result.data);
        const firstCategoryId = result.data[0]._id;
        setOpenCategory(firstCategoryId);
        fetchSubcategories(firstCategoryId, true);
      }
    } catch (err) {
      console.log("Category API Error:", err);
    }
  };

  const fetchSubcategories = async (categoryId, autoSelect = false) => {
    try {
      const res = await fetch(getApiUrl("subcategory-product-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userid: UserId, categoryid: categoryId }),
      });
      const result = await res.json();
      if (result.success) {
        setSubcategories((prev) => ({ ...prev, [categoryId]: result.data }));

        if (autoSelect && result.data.length > 0) {
          const match = disabledSubcategory
            ? result.data.find((s) => s._id === disabledSubcategory)
            : null;

          const subIdToSelect = match ? match._id : result.data[0]._id;

          setActiveSubcategory(subIdToSelect);
          onSubCategorySelect(subIdToSelect);
        }
      }
      if (initialSubcategory) {
        setActiveSubcategory(initialSubcategory);
        onSubCategorySelect(initialSubcategory);
        return;
      }
    } catch (err) {
      console.log("Subcategory API Error:", err);
    }
  };

  const toggleDropdown = (categoryId) => {
    setOpenCategory(categoryId);
    if (!subcategories[categoryId]) fetchSubcategories(categoryId);
  };

  return (
    <>
     
      <div
        className="p-3 bg-white sidebar shadow d-none d-md-block position-sticky top-0"
       
      >
        <h5 className="fw-bold text-center mb-4">BSK BOUTIQUE</h5>
        <ul className="nav flex-column">
          {categories.map((cat) => (
            <li key={cat._id} className="mb-2 border rounded p-2">
              <div
                className="d-flex justify-content-between fw-bold"
                onClick={() => toggleDropdown(cat._id)}
                style={{ cursor: "pointer" }}
              >
                {cat.name}
                <i
                  className={`fa-solid ${
                    openCategory === cat._id
                      ? "fa-chevron-up"
                      : "fa-chevron-down"
                  }`}
                />
              </div>

              {openCategory === cat._id && subcategories[cat._id] && (
                <ul className="nav flex-column ms-3 mt-2">
                  {subcategories[cat._id].map((sub) => (
                    <li key={sub._id}>
                      <span
                        className={`nav-link ${
                          activeSubcategory === sub._id
                            ? "fw-bold text-primary"
                            : "text-dark"
                        } ${
                          disabledSubcategory && disabledSubcategory !== sub._id
                            ? "text-muted disabled"
                            : ""
                        }`}
                        style={{
                          cursor:
                            disabledSubcategory &&
                            disabledSubcategory !== sub._id
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={() => {
                          if (
                            disabledSubcategory &&
                            disabledSubcategory !== sub._id
                          )
                            return;
                          setActiveSubcategory(sub._id);
                          onSubCategorySelect(sub._id);
                        }}
                      >
                        {sub.name}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* MOBILE */}
      <div className="d-md-none mobile-category-scroll">
        {categories.map((cat) => (
          <div
            key={cat._id}
            className={`mobile-category-item ${
              openCategory === cat._id ? "fw-bold text-primary" : ""
            }`}
            onClick={() => toggleDropdown(cat._id)}
          >
            {cat.name}
            <i
              className={`fa-solid ${
                openCategory === cat._id ? "fa-chevron-up" : "fa-chevron-down"
              }`}
            />
          </div>
        ))}
      </div>

      {openCategory && (
        <div className="d-md-none mobile-subcategory-box">
          {subcategories[openCategory]?.map((sub) => (
            <div
              key={sub._id}
              className={`mobile-sub-item ${
                activeSubcategory === sub._id ? "active-sub" : ""
              } ${
                disabledSubcategory && disabledSubcategory !== sub._id
                  ? "disabled"
                  : ""
              }`}
              style={{
                cursor:
                  disabledSubcategory && disabledSubcategory !== sub._id
                    ? "not-allowed"
                    : "pointer",
              }}
              onClick={() => {
                if (disabledSubcategory && disabledSubcategory !== sub._id)
                  return;
                setActiveSubcategory(sub._id);
                onSubCategorySelect(sub._id);
              }}
            >
              {sub.name}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DynamicSidebar;
